import type {BuyflowState} from '@/lib/TypesOpenApi';
import {persist} from '@/lib/vatio-persistence';
import {resetCartState} from '../(state)/CartStore';
import {resetHeaderWidget} from '../(state)/HeaderStore';
import {resetNotificationPreferencesState} from '../(state)/NotificationPreferencesStore';
import {resetPhoneQuestionnaireState} from '../(state)/PhoneQuestionnaireStore';
import {resetPreconfigState} from '../(state)/PreconfigStore';
import {resetScheduleState} from '../(state)/ScheduleStore';
import {resetStreamingState} from '../(state)/StreamingStore';
import {resetVerifyState} from '../(state)/VerifyStore';
import {resetWifiSetupState} from '../(state)/WifiSetupStore';
import {resetLocalHistoryState} from './LocalHistoryState';

export interface BuyflowStore {
  state?: BuyflowState;
}

/**
 * Store to persist back-end response between sessions
 * must be treaded os old in comparision to rest of the applicatin data
 * if add any new field, add the new field to the below reset function also
 * */
export const buyflowStore = persist<BuyflowStore>('buyflow', {
  state: undefined,
});

export const resetBuyflowStore = () => {
  buyflowStore.state = undefined;
};

export const setBuyflowState = (state: BuyflowState) => {
  buyflowStore.state = state;
  // Avoid storing PII in local storage.
  buyflowStore.state.userDetails = undefined;
  if (buyflowStore.state.userSelection) {
    buyflowStore.state.userSelection.userInfo = undefined;
  }
};

// reset persist state of buyflow which are stored in localStorage
export const resetPersistBuyflowState = () => {
  resetBuyflowStore();
  resetLocalHistoryState();
  resetCartState();
  resetHeaderWidget();
  resetNotificationPreferencesState();
  resetPhoneQuestionnaireState();
  resetPreconfigState();
  resetScheduleState();
  resetStreamingState();
  resetVerifyState();
  resetWifiSetupState();
  // in case some new fields in state are not added to the above reset functions
  localStorage.clear();
  sessionStorage.clear();
};
